<template>
  <div v-click-outside="closeTagPopup">
    <TagTriggerBtn @showTagPopup="showPopup = !showPopup" />
    <TagPopup v-if="showPopup"/>
  </div>
</template>

<script>
import TagTriggerBtn from "./TagTriggerBtn.component";
import TagPopup from "./TagPopup.component";
import vClickOutside from "v-click-outside";

export default {

  name: "Tag",
  components: {TagPopup, TagTriggerBtn },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props:{
    tag:{
      type: Object,
      required: true
    },
    tagTemplate:{
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPopup: false
    };
  },
  methods:{
    closeTagPopup(){
      this.showPopup = false
    }
  },

};
</script>

<style scoped></style>
